// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { Button, ButtonComposed, Link, modal } from "@lifepay/rc-ui-toolkit";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
import { LOCK_KEYS } from "accessConfig";
import CardPinChange from "data-containers/CardPinChange";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CardChangePinControl.m.scss";

@themr("@lifepay/CardChangePinControl", styles)
export default class CardChangePinControl extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    cardId: PropTypes.string,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      submitButtonState: "normal",
    };
  }

  render() {
    const { theme, cardId, onSuccess } = this.props;
    const { loading, error, submitButtonState } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <Lock
                lockId={LOCK_KEYS.CARD_PIN_CHANGE}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Сменить пинкод"}
                </Button>
              </Lock>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => (!loading ? close() : null)}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CardPinChange cardId={cardId}>
                  {({ setCardForPinChange }) => {
                    const submit = (
                      <div className={classnames(theme.submit)}>
                        <ButtonComposed
                          state={submitButtonState}
                          disabled={submitButtonState !== "normal"}
                          type={"main"}
                          size={"small"}
                          text={"Подтвердить"}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            this.setState({
                              loading: true,
                              submitButtonState: "loading",
                            });
                            setCardForPinChange({
                              update: (proxy, response) => {
                                this.setState({
                                  loading: false,
                                  submitButtonState: "normal",
                                });
                                onSuccess();
                                close();
                              },
                            }).catch((e) => {
                              this.setState({
                                loading: false,
                                error: e,
                                submitButtonState: "error",
                              });
                            });
                          }}
                        >
                          {"Перевести на IVR"}
                        </ButtonComposed>
                        <Button
                          type={loading ? "disabled" : "alt"}
                          size={"small"}
                          disabled={loading}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            close();
                          }}
                        >
                          {"Отмена"}
                        </Button>
                      </div>
                    );

                    return (
                      <div className={classnames(theme["modal-content"])}>
                        <div>
                          <div
                            className={classnames(theme.summary)}
                          >{`Перевести клиента на IVR для смены pin-кода`}</div>
                          {error ? (
                            <React.Fragment>
                              <div className={classnames(theme.summary)}>
                                {error.message}
                              </div>
                              <div className={classnames(theme.summary)}>
                                <Link
                                  type={"negative"}
                                  withRouter={false}
                                  onClick={() => {
                                    this.setState({
                                      error: null,
                                      submitButtonState: "normal",
                                    });
                                  }}
                                >
                                  {"Очистить ошибку"}
                                </Link>
                              </div>
                            </React.Fragment>
                          ) : null}
                        </div>
                        {submit}
                      </div>
                    );
                  }}
                </CardPinChange>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardChangePinControl/CardChangePinControl.js